import {
  useQuery
} from '@tanstack/vue-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  computed,
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  BackendErrorEntity,
  GetOrderResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiGetOrderBuyerDetail = (
    id: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      id = unref(id);
      
      return fetchApiInstance<GetOrderResponseDto>(
      {url: `/orders/${id}/detail`, method: 'GET'
    },
      options);
    }
  

export const getApiGetOrderBuyerDetailQueryKey = (id: MaybeRef<string | undefined | null>,) => {
    return ['orders',id,'detail'] as const;
    }

    
export const getApiGetOrderBuyerDetailQueryOptions = <TData = Awaited<ReturnType<typeof apiGetOrderBuyerDetail>>, TError = ErrorType<BackendErrorEntity>>(id: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetOrderBuyerDetail>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetOrderBuyerDetailQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetOrderBuyerDetail>>> = () => apiGetOrderBuyerDetail(id, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetOrderBuyerDetail>>, TError, TData> 
}

export type ApiGetOrderBuyerDetailQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetOrderBuyerDetail>>>
export type ApiGetOrderBuyerDetailQueryError = ErrorType<BackendErrorEntity>



export function useApiGetOrderBuyerDetail<TData = Awaited<ReturnType<typeof apiGetOrderBuyerDetail>>, TError = ErrorType<BackendErrorEntity>>(
 id: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetOrderBuyerDetail>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetOrderBuyerDetailQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



